import React from 'react';

import Page from 'components/page';
import SolutionTemplate from 'components/solutionTemplate';
import { CTAS } from 'context/solutions/constants';

const sections = [
  {
    title: 'Forward Contracts',
    image: 'products/forward-contracts.jpg',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    description: `
      AFEX Forward Contracts provide processors with a product that 
      allows them to ensure the availability of raw materials for their 
      activities as well as an ability to hedge price risk. It also gives 
      the seller, typically a producer or trader, the opportunity to 
      participate in the upward price movement of the commodity without 
      undue exposure to market or price risks.`,
  },
  {
    title: 'Asset Backed Commercial Papers (ABCP)',
    image: 'products/asset-backed-commercial-papers.jpg',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    description: `
      Commodity buyers/off-takers, especially processors and manufacturers 
      require a reliable and sustainable source of funding to cover 
      the purchase of commodities during the early stages of the harvest 
      period to take advantage of the low prices and mitigate the expected 
      upward trend in prices. ABCPs enable companies to raise short-term 
      funds on a continuum through issuing of notes for subscription.`,
  },
  {
    title: 'Exchange Traded Commodities (ETCs)',
    image: 'products/exchange-traded-commodities.jpg',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    description: `
      ETCs are investment vehicles (asset backed securities) that tracks 
      and replicates the performance of an underlying commodity index including 
      total return indices based on a single commodity. ETCs are similar to 
      Exchange Traded Funds (ETFs) and are traded and settled like normal 
      shares on their own dedicated sector. ETCs have dedicated market maker 
      support enabling investors to gain exposure to commodities on Exchanges 
      during trading hours.`,
  },
  {
    title: 'ComX',
    image: 'products/comX.jpg',
    ctas: [CTAS.READ_MORE, CTAS.START_TRADING],
    description: `
      AFEX's ComX is the electronic platform where securitized agricultural 
      assets are traded. ComX is designed to provide the market with a user friendly 
      and efficient shared-infrastructure, allowing clients of the exchange to 
      put up trades themselves as well as allowing brokers to do 
      so on their behalf.`,
  },
];

const WorkbenchPage = () => {
  return (
    <Page pageName="efficientMarkets">
      <SolutionTemplate sections={sections} />
    </Page>
  );
};

export default WorkbenchPage;
